// Copyright (c) 2016 Deere & Company

import PipProduct, {getDefaultState as getPipProductDefaultState} from '@deere/cps-it.warranty-model-factory/lib/pip-product';

export const getDefaultState = () => getPipProductDefaultState();

export default PipProduct;



// WEBPACK FOOTER //
// ./src/pip/pip-code/state/pip-product.js